import { render, staticRenderFns } from "./AbkGallerySectionForm.vue?vue&type=template&id=1ce036f1&scoped=true&"
import script from "./AbkGallerySectionForm.vue?vue&type=script&lang=js&"
export * from "./AbkGallerySectionForm.vue?vue&type=script&lang=js&"
import style0 from "./AbkGallerySectionForm.vue?vue&type=style&index=0&id=1ce036f1&scoped=true&lang=scss&"
import style1 from "./AbkGallerySectionForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce036f1",
  null
  
)

export default component.exports